import React, { useState, useEffect } from "react";
import styles from './TravelInfoMain.module.css'
import {useHistory} from 'react-router-dom'

import { connect } from "react-redux";
import changePassportDetails from "../../../store/Actions/PassportDetailsAction";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import Radio from "@material-ui/core/Radio";


function TravelInfoMain(props) {

  useEffect(()=>{
    if(props.passportDetails.application !== true){
      history.push('/dashboard/my-applications')
    }
    else{
      setId(props.passportDetails.id)
      if(props.passportDetails.departure_city !== undefined){
        setBooked(props.passportDetails.is_ticket_booked)
        setDepartureCity(props.passportDetails.departure_city)
        setArrivalCity(props.passportDetails.arrival_city)
        setDepartureAirlineName(props.passportDetails.departure_airline)
        setDepartureDate(props.passportDetails.departure_date_date)
        setDepartureMonth(props.passportDetails.departure_date_month)
        setDepartureYear(props.passportDetails.departure_date_year)
        setArrivalDate(props.passportDetails.arrival_date_date)
        setArrivalMonth(props.passportDetails.arrival_date_month)
        setArrivalYear(props.passportDetails.arrival_date_year)
      }
    }
  },[])

  const [booked, setBooked] = useState("");

  const [departureCity, setDepartureCity] = useState("");
  const [arrivalCity, setArrivalCity] = useState("")
  const [departureAirlineName, setDepartureAirlineName] = useState("");

  const [departureDate, setDepartureDate] = useState("");
  const [departureMonth, setDepartureMonth] = useState("");
  const [departureYear, setDepartureYear] = useState("");

  const [arrivalDate, setArrivalDate] = useState("");
  const [arrivalMonth, setArrivalMonth] = useState("");
  const [arrivalYear, setArrivalYear] = useState("");

  const history = useHistory()
  const [id,setId] = useState("")

  const checkDepartureDate = (e) => {
    if(e.length <= 2 && e < 32 && e !== "00"){
        setDepartureDate(e)
    }
  }
  const checkDepartureMonth = (e) => {
    if(e.length <= 2 && e < 13 && e !== "00"){
        setDepartureMonth(e)
    }
  }  
  const checkDepartureYear = (e) => {
    if(e.length <= 4 && e !== "0000"){
        setDepartureYear(e)
    }
  }

  const checkArrivalDate = (e) => {
    if(e.length <= 2 && e < 32 && e !== "00"){
      setArrivalDate(e)
    }
  }
  const checkArrivalMonth = (e) => {
    if(e.length <= 2 && e < 13 && e !== "00"){
      setArrivalMonth(e)
    }
  }
  const checkArrivalYear = (e) => {
    if(e.length <= 4 && e !== "0000"){
      setArrivalYear(e)
    }
  }


  const goLater = () => {
    alert("save and later")
  }

  const go = () => {
    if(booked === "NO"){
      const data = {
        ...props.passportDetails,
        departure_date:"",
        arrival_date: "",
        departure_city: "",
        arrival_city: "",
        departure_airline: "",
        is_ticket_booked: booked,
        arrival_date_date: "",
        arrival_date_month: "",
        arrival_date_year: "",
        departure_date_date: "",
        departure_date_month: "",
        departure_date_year: ""
    }
     
    props.ChangePassportDetails(data)
    history.push(`/dashboard/my-applications/${id}/upload-other-docs`)
    }

    else{

    if(booked === "" || departureCity === "" || arrivalCity === "" || departureAirlineName === "" || departureDate === "" || departureMonth === "" || departureYear === "" || arrivalDate === "" || arrivalMonth === "" || arrivalYear === "" ){
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          All Field Are Required!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }
    
    else if (departureYear.length !== 4 || arrivalYear.length !== 4){
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="22" />
          &nbsp; Years Must Be 4 Digits!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }
    // else if(!(arrivalYear >= departureYear)){
    //   toast.error(
    //     <span style={{ display: "flex", alignItems: "center" }}>
    //       <BiError size="22" />
    //       &nbsp; Arrival Year Must Be Greater Than Or Equal To Departure Year!
    //     </span>,
    //     {
    //       position: "bottom-left",
    //       autoClose: 5000,
    //       hideProgressBar: true,
    //       closeOnClick: true,
    //       pauseOnHover: false,
    //       draggable: true,
    //       progress: undefined,
    //     }
    //   );
    // }
    else if(((new Date(arrivalYear, (arrivalMonth - 1), arrivalDate, 0, 0, 0, 0)).toISOString()) < ((new Date(departureYear, (departureMonth - 1), departureDate, 0, 0, 0, 0)).toISOString())){
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="22" />
          &nbsp; Arrival Date Must Be Greater Than Or Equal To Departure Date!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }
    else{
    const data = {
        ...props.passportDetails,
        departure_date: (new Date(departureYear, (departureMonth - 1), departureDate, 0, 0, 0, 0)).toISOString(),
        arrival_date: (new Date(arrivalYear, (arrivalMonth - 1), arrivalDate, 0, 0, 0, 0)).toISOString(),
        departure_city: departureCity,
        arrival_city: arrivalCity,
        departure_airline: departureAirlineName,
        is_ticket_booked: booked,
        arrival_date_date: arrivalDate,
        arrival_date_month: arrivalMonth,
        arrival_date_year: arrivalYear,
        departure_date_date: departureDate,
        departure_date_month: departureMonth,
        departure_date_year: departureYear
    }
     
    props.ChangePassportDetails(data)
    history.push(`/dashboard/my-applications/${id}/upload-other-docs`)
    
  }
}
  }
  console.log(props.passportDetails)
  return (
    <div>
      <h2 className={styles.head}>Application Form</h2>
      <div className={(booked === "NO")?(styles.mainBox1):(styles.mainBox)} >
        <div className={styles.box1FirstCont}>
          <p className={styles.badge}>3</p>
          <p className={styles.FirstText}>Travel Information</p>
        </div>
        <hr className={styles.line} />
        <div className={styles.inputsBox1}>
        <div>
            <label for="Have you booked your flight tickets?" className={styles.label}>
            Have you booked your flight tickets?
            </label>
            <br />
            <span>
                <span>
                  <Radio
                    onChange={() => {
                      setBooked("YES")
                    }}
                    checked={booked === "YES"}
                    value="normal"
                    color="default"
                    name="Booked"
                  />
                  Yes
                  </span>
                  <span className={styles.littleMar}>
                  <Radio
                    onChange={() => {
                        setBooked("NO")
                    }}
                    checked={booked === "NO"}
                    value="No"
                    color="default"
                    name="Booked"
                  />
                  No
                </span>
            </span>
          </div>

        </div>
        {(booked === "NO")?null:(
          <>
          <div className={styles.inputsBox}>
          <div>
            <label for="Departure City" className={styles.label}>
             Departure City<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              id="Departure City"
              className={styles.input}
              value={departureCity}
              onChange={(e) => setDepartureCity(e.target.value)}
            />
          </div>
          <div>
            <label for="Arrival City" className={styles.label}>
            Arrival City<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              id="Arrival City"
              className={styles.input}
              value={arrivalCity}
              onChange={(e) => setArrivalCity(e.target.value)}
            />
          </div>
          <div>
            <label for="Departure Airline Name" className={styles.label}>
            Departure Airline Name<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
               <input
              type="text"
              id="Departure Airline Name"
              className={styles.input}
              value={departureAirlineName}
              onChange={(e) => setDepartureAirlineName(e.target.value)}
            />
          </div>
          {/* <div>
            <label for="Place of birth" className={styles.label}>
              Place of birth<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <input
              type="text"
              id="Place of birth"
              className={styles.input}
              value={placeOfBirth}
              onChange={(e) => setPlaceOfBirth(e.target.value)}
            />
          </div> */}
        </div>
        <div className={styles.inputsBox}>
          <div>
            <label for="Departure Date" className={styles.label}>
            Departure Date<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span 
              className={styles.input2}
            >
              <input type="number"className={styles.inputIn} min="1" max="31" maxLength="2"  value={departureDate} onChange={(e) => checkDepartureDate(e.target.value)} />
              <input type="number"className={styles.inputIn}  min="1" max="12" maxLength="2"  value={departureMonth} onChange={(e) => checkDepartureMonth(e.target.value)} />
              <input type="number"className={styles.inputIn2} maxLength="2" value={departureYear} onChange={(e) => checkDepartureYear(e.target.value)} />
            </span>
          </div>
          <div>
            <label for="Arrival Date" className={styles.label}>
             Arrival Date<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span 
              className={styles.input2}
            >
              <input type="number"className={styles.inputIn} min="1" max="31" maxLength="2"  value={arrivalDate} onChange={(e) => checkArrivalDate(e.target.value)} />
              <input type="number"className={styles.inputIn}  min="1" max="12" maxLength="2"  value={arrivalMonth} onChange={(e) => checkArrivalMonth(e.target.value)} />
              <input type="number"className={styles.inputIn2} maxLength="2" value={arrivalYear} onChange={(e) => checkArrivalYear(e.target.value)} />
            </span>
          </div>
        </div>
          </>
        ) }
        
        <div className={styles.btns}>
          {/* <button className={styles.btn1} onClick={()=>goLater()}>Save and continue later</button> */}
          <button className={styles.btn2} onClick={()=>go()}>Continue</button>
        </div>
      </div>


      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}


const mapStateToProps = (state) => ({
  passportDetails: state.PassportDetails.passportDetails,
});

const mapDispatchToProp = (dispatch) => ({
  ChangePassportDetails: (passportDetails) => dispatch(changePassportDetails(passportDetails)),
});

export default connect(mapStateToProps, mapDispatchToProp)(TravelInfoMain);
